import _get from "lodash/get";
export var isInBrowser = function isInBrowser() {
  return typeof window !== 'undefined' && _get(window, 'navigator.product') !== 'ReactNative';
};